import type { BoardObject } from '../../shared/types.ts';
import { toLocal } from '../util/geometry.ts';
import { hitStroke } from './freehand.ts';

/** Whether world point (px, py) hits `o`, with `tol` world units of slack. */
export function hitObject(o: BoardObject, px: number, py: number, tol = 0): boolean {
  const [lx, ly] = toLocal(o, px, py);
  if (lx < -tol || ly < -tol || lx > o.w + tol || ly > o.h + tol) return false;
  if (o.type === 'freehand') return hitStroke(o, lx, ly, tol);
  // Frames are hit on their border only, so you can marquee-select inside them.
  if (o.type === 'frame') return lx <= tol || ly <= tol || lx >= o.w - tol || ly >= o.h - tol;
  if (o.type !== 'shape' || o.kind === 'rect') return true;

  // Normalise to -1..1 over the slack-expanded box.
  const nx = ((lx + tol) / (o.w + 2 * tol)) * 2 - 1;
  const ny = ((ly + tol) / (o.h + 2 * tol)) * 2 - 1;
  switch (o.kind) {
    case 'ellipse': return nx * nx + ny * ny <= 1;
    case 'diamond': return Math.abs(nx) + Math.abs(ny) <= 1;
    case 'triangle': return ny <= 1 && Math.abs(nx) <= (ny + 1) / 2; // apex top-centre
  }
}
